/*global google*/

export const placesAutocomplete = (input: string, sessionToken: any, countries: string[]) => {
    return new Promise<{ value: string; label: string }[]>((resolve, reject) => {
        try {
            const service = new google.maps.places.AutocompleteService();

            service.getPlacePredictions(
                {
                    input,
                    sessionToken,
                    componentRestrictions: countries?.length ? { country: countries } : undefined,
                },
                (predictions, status) => {
                    if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
                        return resolve([]);
                    }

                    const results = predictions.map(prediction => ({
                        value: prediction.place_id,
                        label: prediction.description,
                    }));

                    resolve(results);
                }
            );
        } catch (error) {
            console.error(error);
            reject(error);
        }
    });
};

export const generateSessionToken = () => {
    return new google.maps.places.AutocompleteSessionToken();
};

export const getPlaceDetails = (placeId: string, uk?: boolean): Promise<any | undefined> => {
    return new Promise((resolve, _reject) => {
        const service = new google.maps.places.PlacesService(document.createElement("div"));

        const request = {
            placeId,
            fields: ["address_components"],
        };

        service.getDetails(request, (place, status) => {
            if (status !== google.maps.places.PlacesServiceStatus.OK) {
                console.error("Google Places API Error:", status);
                return resolve(undefined);
            }

            const addressComponents = {
                number: "",
                streetAddress: "",
                locality: "",
                neighborhood: "",
                city: "",
                county: "",
                country: "",
                postalCode: "",
            };

            for (const component of place?.address_components || []) {
                const types = component.types;

                if (types.includes("street_number")) {
                    addressComponents.number = component.long_name;
                } else if (types.includes("route")) {
                    addressComponents.streetAddress = component.long_name;
                } else if (types.includes("locality")) {
                    addressComponents.locality = component.long_name;
                    if (!addressComponents.city) {
                        addressComponents.city = component.long_name;
                    }
                } else if (types.includes("neighborhood")) {
                    addressComponents.neighborhood = component.long_name;
                } else if (types.includes("postal_town")) {
                    addressComponents.city = component.long_name;
                } else if (types.includes("administrative_area_level_3")) {
                    if (!addressComponents.city) {
                        addressComponents.city = component.long_name;
                    }
                } else if (types.includes("administrative_area_level_2")) {
                    if (!addressComponents.city) {
                        addressComponents.city = component.long_name;
                    }
                    addressComponents.county = component.long_name;
                } else if (types.includes("country")) {
                    addressComponents.country = component.long_name;
                } else if (types.includes("postal_code")) {
                    addressComponents.postalCode = component.long_name;
                }
            }

            const formatted = uk
                ? {
                    address1: `${addressComponents.number ? `${addressComponents.number.trim()}, ` : ""}${addressComponents.streetAddress?.trim() || ""}`,
                    address2: `${addressComponents.neighborhood ? `${addressComponents.neighborhood.trim()}, ` : ""}${addressComponents.locality?.trim() || ""}`,
                    city: addressComponents.city?.trim(),
                    country: addressComponents.country,
                    postcode: addressComponents.postalCode?.trim(),
                }
                : {
                    streetAddress: `${addressComponents.number}, ${addressComponents.streetAddress}, ${addressComponents.neighborhood}, ${addressComponents.locality}`,
                    city: addressComponents.city?.trim(),
                    county: addressComponents.county,
                    country: addressComponents.country,
                    postalCode: addressComponents.postalCode?.trim(),
                };

            resolve(formatted);
        });
    });
};
